import { AuthService } from './../../../services/user/auth.service';
import { PermsService } from './../../../services/utils/perms.service';
import { PermissionConfiguration, Permission } from './../../../models/permission.model';
import { Component, OnInit } from "@angular/core";
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import { Movement } from "../../../models/loyalty-movement.model";
import { LoyaltyMovementService } from "../../../services/loyalty/loyalty-movement.service";

@Component({
  selector: 'kv-loyalty-account-balance',
  templateUrl: 'loyalty-account-balance.component.html'
})
export class LoyaltyAccountBalanceComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  searchPressed = false;
  movements: Movement[];
  actualBalance: number;
  customerIdforExport: number;
  //KS-6867 nuovo parametro per permettere l'export o meno
  movementExportExcelPermission= false;


  // Permission Gabrielli
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  constructor(
    private svcMovement: LoyaltyMovementService,
    private permSrv: PermsService,
    private authService: AuthService
  ) {

  }




  onSearch(filters) {

    //adattato solo nel caso getAllMovementsFiltered in quanto non c'entra MagazziniGabrielli
    if (!this.customerMgPermission) {
      this.svcMovement.getAllMovementsFiltered(filters).subscribe(movements => {
        this.setMovements(movements.data);
        // Estrai il customerId dal primo oggetto dell'array
        if (movements.data.length > 0) {
          this.customerIdforExport = movements.data[0].customerId;
        } else {
          this.customerIdforExport = null; // o un valore di default
        }


      });
    } else {
      this.svcMovement.getKloyMovements(filters, this.authService.user.selectedCompany).subscribe(res => {
        if (res.data.length > 0) {
          this.actualBalance = res.data[0]['CurrentBalance'] || 0;
          if (res.data[0]['Transactions']) {
            this.setMovements(res.data[0]['Transactions']);
          }
        } else {
          this.setMovements([]);
        }
      });
    }
  }

  setMovements(movements) {
    this.movements = movements;
    this.searchPressed = true;
  }
  readyPermission=false;
  ngOnInit() {
    //verifica permission customer
    this.permSrv.getCustomerPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        console.log(perm)
        switch (perm.operationName) {
          case 'customer-mg':
            if (perm.allowsGET) this.customerMgPermission = true;
            break;
        
        }
      });
    });

    this.permSrv.getLoyaltyPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        console.log(perm)
        switch (perm.operationName) {
          //KS-6867 nuovo parametro :valorizzazione per export
          case 'movement-export-excel':
            if (perm.allowsGET) this.movementExportExcelPermission = true;
            break;
        }
        this.readyPermission=true;
      });
    });
  }








}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance.component.ts